import { useEffect, useRef } from 'react'
import { IntegrationsStore } from '@/core/store/Integrations/integrations.store'
import { IntegrationsModule } from '@/core/modules/integrations'

export const useRefreshIntegrations = (): void => {
    const { pendingIntegrationProvidersIds } = IntegrationsStore.useStore()
    const isFirstTime = useRef(true)

    useEffect(() => {
        if (
            !isFirstTime.current &&
            pendingIntegrationProvidersIds.length === 0
        ) {
            IntegrationsModule.loadIntegrations(true)
        }
        isFirstTime.current = false
    }, [pendingIntegrationProvidersIds])
}
